module.exports = __webpack_public_path__ + "static/media/personalize.be560105.mp4";